// extracted by mini-css-extract-plugin
export default {"button":"style-module--button--c8534"};